import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getAdminOnline } from '../../../services/adminApi';
import { Tag } from '../catalog/ui';

// « En ligne maintenant » (2026-10-24) : qui a donné signe de vie dans les 2 dernières minutes — compte (e-mail), compte anonyme,
// visiteur ou équipe —, d'où (pays), sur quelle page et avec quel appareil. Relu toutes les 30 s. Voir backend/services/analytics/presence.js.
const RELIRE_MS = 30 * 1000;
const TON = { compte: 'ok', anonyme: 'warn', visiteur: 'mute', equipe: '' };

export default function OnlineCard() {
  const { t, i18n } = useTranslation('admin');
  const [liste, setListe] = useState(null);
  const [erreur, setErreur] = useState('');

  const charger = useCallback(async () => {
    try { const r = await getAdminOnline(); setListe(Array.isArray(r?.online) ? r.online : []); setErreur(''); } catch (err) { setErreur(err?.message || t('stats.loadFailed')); }
  }, [t]);
  useEffect(() => {
    charger();
    const minuteur = setInterval(charger, RELIRE_MS);
    return () => clearInterval(minuteur);
  }, [charger]);

  let noms = null;
  try { noms = new Intl.DisplayNames([i18n.language], { type: 'region' }); } catch (_e) { noms = null; }
  const nomDuPays = (code) => {
    if (!code) return t('stats.unknown');
    try { return (noms && noms.of(code)) || code; } catch (_e) { return code; }
  };
  const depuis = (iso) => {
    const minutes = Math.max(0, Math.round((Date.now() - Date.parse(iso)) / 60000));
    return minutes < 1 ? t('stats.online.justNow') : t('stats.online.minutes', { count: minutes });
  };
  const autres = liste ? liste.filter((p) => p.type !== 'equipe').length : 0;

  return (
    <section className="adm-card" aria-live="polite">
      <div className="adm-actions">
        <h2>{t('stats.online.title')}</h2>
        {liste && <Tag tone={autres > 0 ? 'ok' : 'mute'}>{t('stats.online.count', { count: autres })}</Tag>}
      </div>
      <p className="adm-note">{t('stats.online.note')}</p>
      {erreur && <p className="adm-error" role="alert">{erreur}</p>}
      {liste && liste.length === 0 && <p className="adm-note">{t('stats.online.empty')}</p>}
      {liste && liste.length > 0 && (
        <div className="adm-tbl">
          <table>
            <thead><tr><th>{t('stats.online.cols.who')}</th><th>{t('stats.online.cols.where')}</th><th>{t('stats.online.cols.page')}</th><th>{t('stats.online.cols.since')}</th></tr></thead>
            <tbody>
              {liste.map((p, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <tr key={`${p.type}-${p.since}-${i}`}>
                  <td>
                    <Tag tone={TON[p.type]}>{t(`stats.online.types.${p.type}`)}</Tag>
                    {p.email && <small>{p.email}</small>}
                  </td>
                  <td>{nomDuPays(p.country)}<small>{t(`stats.devices.${p.device}`, { defaultValue: p.device })}</small></td>
                  <td><code>{p.page}</code></td>
                  <td>{depuis(p.since)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
